import { forwardRef, useRef, useImperativeHandle } from "react";
import { useInputStyling } from "@/autocomplete/hooks/useInputStyling";

interface SearchInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
    query: string;
}

export const SearchInput = forwardRef<HTMLInputElement, SearchInputProps>(
    ({ query, ...inputProps }, ref) => {
        const internalRef = useRef<HTMLInputElement>(null);

        useImperativeHandle(ref, () => internalRef.current!);
        useInputStyling(internalRef, query);

        return (
            <input
                ref={internalRef}
                className="algoliaAutocompleteForm__input"
                autoComplete="off"
                {...inputProps}
            />
        );
    }
);

SearchInput.displayName = "SearchInput";